const recentViewdProduct = document.querySelector(".recently_viewed_proudct");
const recentViewedProductHandle = recentViewdProduct.dataset.productHandle;
var LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY = "shopify-recent-view";
var LOCAL_STORAGE_DELIMITER = ",";

var selectors = {
  grid: "[grid-recentViewProduct]",
};

document.addEventListener("DOMContentLoaded", function () {
  var productHandle = recentViewedProductHandle || false;
  if (!productHandle) return;
  updaterecentViewPorduct(productHandle);

  var Recentgrid = document.querySelector(selectors.grid) || false;
  if (Recentgrid) {
    recentViewsetupGrid(Recentgrid);
  }
});

var recentViewsetupGrid = function (Recentgrid) {
  var recentViewPorduct = getrecentViewPorduct();

  var requestsRecentViewed = recentViewPorduct
    .slice(0)
    .reverse()
    .map(function (handle) {
      if (recentViewedProductHandle !== handle) {
        return fetch("/products/" + handle + "?view=card").then(function (res) {
          if (res.status == 200) return res.text();
        });
      }
    });

  Promise.all(requestsRecentViewed).then(function (responses) {
    var cards = responses.filter(Boolean).join("");
    if (cards) {
      Recentgrid.innerHTML = cards;
      recentViewdProduct.classList.remove("no-js-inline");
    }
  });
};

var getrecentViewPorduct = function () {
  var stored = localStorage.getItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY) || false;
  if (stored) return stored.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setrecentViewPorduct = function (array) {
  var joined = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY, joined);
  return joined;
};

var updaterecentViewPorduct = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  var index = recentViewPorduct.indexOf(handle);
  if (index === -1) {
    recentViewPorduct.push(handle);
  } else {
    var current = recentViewPorduct.splice(index, 1);
    recentViewPorduct.push(current);
  }
  return setrecentViewPorduct(recentViewPorduct);
};
